import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["dashboardUrl", "onExitClick"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import useBackToCampaign from 'campaigns-lib/hooks/useBackToCampaign';
import { jsx as _jsx } from "react/jsx-runtime";
const sharedButtonProps = {
  size: 'small',
  use: 'secondary-ghost'
};
const ExitButton = props => {
  const {
      dashboardUrl,
      onExitClick
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleExitClick = (...args) => {
    if (onExitClick) {
      onExitClick(...args);
    }
  };
  const ExitMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "components.header.backLink.exit"
  });
  const renderBackLinkComponent = () => /*#__PURE__*/_jsx(Button, Object.assign({
    href: dashboardUrl,
    onClick: handleExitClick
  }, sharedButtonProps, rest, {
    children: ExitMessage
  }));
  const {
    shouldDisplayBackToCampaign,
    BackToCampaignComponent
  } = useBackToCampaign();
  if (shouldDisplayBackToCampaign) {
    return /*#__PURE__*/_jsx(BackToCampaignComponent, {
      renderFallbackComponent: renderBackLinkComponent,
      use: "button",
      applicationId: "ContentEditorUI",
      label: ExitMessage,
      buttonProps: {
        size: 'small',
        use: 'secondary-ghost'
      }
    });
  }
  return renderBackLinkComponent();
};
export default ExitButton;